import {ACTION_SET_ROUTES} from "./actions";

const initialState = {
    routes:[]
};

export default function (state = initialState, action) {

    switch ( action.type ){

        case ACTION_SET_ROUTES:
            return { routes: action.payload };
        default:
            return state;

    }

}



// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/reducer.js